import {computed} from 'vue';

import {UserProfile} from "./types";
import {isAuth} from "./authState";
import {useUserProfileQuery} from "./queries";

/**
 * Профиль пользователя из query + производные от него представления.
 *
 * Composable намеренно без побочных эффектов, поэтому его можно звать из любого числа мест:
 * запрос дедуплицируется по ключу. Синхронизация языка — отдельный одноразовый
 * эффект, см. useProfileLocaleSync.
 */
export function useUserProfile() {
    const {data, isFetching} = useUserProfileQuery();

    // Гард по isAuth гасит данные сразу на logout, не дожидаясь очистки кэша
    const profile = computed<UserProfile | null>(() => isAuth.value ? (data.value ?? null) : null);

    // Сотрудники в ролевой модели ссылаются на пользователя строковым id
    const userId = computed<string | null>(() => profile.value ? String(profile.value.id) : null);

    const displayName = computed<string>(() => {
        const currentProfile = profile.value;
        if (!currentProfile) return '';
        return `${currentProfile.firstname ?? ''} ${currentProfile.lastname ?? ''}`.trim() || currentProfile.email;
    });

    return {
        profile,
        userId,
        displayName,
        isProfileFetching: isFetching,
    };
}
